const defaultState = () => ({
  details_rule: {
    severity: undefined,
    name: undefined,
    description: undefined,
    dataSources: [],
    eventTypes: [],
    complexity: undefined,
    cvss: 'CVSS:3.0/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:N',
    variables: undefined,
    siemVendor: undefined
  },
  settings_rule: {
    alertType: undefined,
    timeWindow: undefined,
    cronExpression: undefined,
    expirationTime: undefined,
    trigger: undefined,
    actions: undefined,
    files: []
  },
  code_rule: {
    code: undefined,
  },
  conclusion_rule: {
    conclusion: undefined,
  }
})
export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    details_rule: (state) => state.details_rule,
    settings_rule: (state) => state.settings_rule,
    code_rule: (state) => state.code_rule,
    conclusion_rule: (state) => state.conclusion_rule,
    all: (state) => {
      return {
        ...state.details_rule,
        ...state.settings_rule,
        ...state.code_rule,
        ...state.conclusion_rule,
      }
    }
  },
  mutations: {
    specific_tab: (state, { id, data }) => {
      state[id] = data
    },
    details_rule: (state, { id, input }) => {
      state.details_rule[id] = input
    },
    settings_rule: (state, { id, input }) => {
      state.settings_rule[id] = input
    },
    code_rule: (state, { id, input }) => {
      state.code_rule[id] = input
    },
    conclusion_rule: (state, { id, input }) => {
      state.conclusion_rule[id] = input
    },
    resetAll: state => {
      state.details_rule = defaultState()['details_rule']
      state.settings_rule = defaultState()['settings_rule']
      state.code_rule = defaultState()['code_rule']
      state.conclusion_rule = defaultState()['conclusion_rule']
    }
  }
}

